import {
  recognizedFixedAddOnHeadings,
  recognizedFixedAddOnUnitHeadings,
  recognizedPercentAddOnHeadings,
} from '@retail/freight/utils';
import { UploadedFreight } from '@retail/freight/types';
import {
  ImportColumnConfig,
  ImportItemsConfig,
  spreadsheetDate,
  spreadsheetNumber,
  spreadsheetString,
} from '@retail/products/components';
import {
  recognizedDiscountGroupHeadings,
  recognizedGroupNumberHeadings,
  recognizedMgItemNrHeadings,
  recognizedValidFromHeadings,
} from '@retail/utils';
import * as yup from 'yup';

export class FreightConditionsImportConfig extends ImportItemsConfig<UploadedFreight> {
  private constructor() {
    super();
  }

  static instance = new FreightConditionsImportConfig();

  override columns: ImportColumnConfig<keyof UploadedFreight>[] = [
    {
      name: 'mgItemNumber',
      recognizedColumnNames: ['MgItemNumber', ...recognizedMgItemNrHeadings],
    },
    {
      name: 'productGroupNumber',
      recognizedColumnNames: ['GroupNumber', ...recognizedGroupNumberHeadings],
    },
    {
      name: 'discountGroupCode',
      recognizedColumnNames: ['GroupCode', ...recognizedDiscountGroupHeadings],
    },
    {
      name: 'validFrom',
      recognizedColumnNames: ['Valid from', ...recognizedValidFromHeadings],
    },
    {
      name: 'percentAddon',
      recognizedColumnNames: ['Percent addon', ...recognizedPercentAddOnHeadings],
    },
    {
      name: 'fixedAddon',
      recognizedColumnNames: ['Fixed addon', ...recognizedFixedAddOnHeadings],
    },
    {
      name: 'fixedAddonUnit',
      recognizedColumnNames: ['Fixed addon unit', ...recognizedFixedAddOnUnitHeadings],
    },
  ];

  override schema = yup
    .object({
      mgItemNumber: spreadsheetNumber(),
      productGroupNumber: spreadsheetString(),
      discountGroupCode: spreadsheetString(),
      validFrom: spreadsheetDate(),
      percentAddon: spreadsheetNumber(),
      fixedAddon: spreadsheetNumber(),
      fixedAddonUnit: spreadsheetString(),
    })
    .test(
      'one-of-addon',
      'At least one of percentAddon, fixedAddon, or fixedAddonUnit must be provided',
      (v) =>
        v.percentAddon !== undefined ||
        v.fixedAddon !== undefined ||
        v.fixedAddonUnit !== undefined
    );

  override templateExampleData = {
    mgItemNumber: [],
    productGroupNumber: [],
    discountGroupCode: [],
    validFrom: [],
    percentAddon: [],
    fixedAddon: [],
    fixedAddonUnit: [],
  };
}
